export default __webpack_public_path__ + "static/media/3D Infotech.371b8834.png";